$(document).ready(function(){
	// track repair signin 
	if(!document.querySelector('.track-status-search')) return false;
	/* PJTWAUS-1 : 20200205 add */
	$('.step-box-inner').find('.active').last().attr('aria-current','step');
	/*// PJTWAUS-1 : 20200205 add */
	// repair service Inquiry
	var rcIq = {
		el: document.getElementById('statusSearchInquiry'), // form
		init: function() {
			rcIq.addEvent();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			// ajax validation
			if($(rcIq.el).checkValidation()) {
				var url = rcIq.el.getAttribute('data-url');
				var param = xssfilter($(rcIq.el).serialize());
				var methodType = $(rcIq.el).data('ajaxMethod');
				// number validation
				$('body').trigger('ajaxLoadBefore');
				ajax.call(url, param, 'json', function(data){
					$('body').trigger('ajaxLoadEnd');
					if(!data.result){
						var block = $(rcIq.el).find('input.case-number').parents('.field-block');
						$(rcIq.el).find('.field-block').addClass('error');
						if(data.msg) {
							block.find('.ajax-msg').text(data.msg);
						}
						block.find('.ajax-msg').show().siblings().hide();
					}else {
						if(data.flag && data.flag != null) {
							rcIq.el.flag.value = data.flag;
						}
						if(data.submitData && data.submitData != null) {
							// rcIq.el.flag.value = data.flag;
							if(!rcIq.el.submitData) {
								$(rcIq.el).append('<input type="hidden" name="submitData" value="">');
							}
							rcIq.el.submitData.value = JSON.stringify(data.submitData);
						}
						rcIq.el.submit();
					}
				}, methodType);
			}
		},
		addEvent: function(){
			$(rcIq.el).on({
				submit: rcIq.beforeSubmit
			});
		}
	};

	rcIq.init();
});